import { disallowedFilenames } from './disallowedFilenames';
import { ignoreErrors } from './ignoreErrors';

const hasDisallowedUrl = (url) => disallowedFilenames.some((df) => url?.startsWith(df));

export const config = {
  beforeSend(event) {
    const hasDisallowedFrame = event.exception?.values?.[0]?.stacktrace?.frames?.some((f) =>
      hasDisallowedUrl(f.filename)
    );

    return hasDisallowedFrame ? null : event;
  },
  beforeSendTransaction(event) {
    const hasDisallowedSpan = event.spans?.some((span) =>
      hasDisallowedUrl(span.description)
    );

    return hasDisallowedSpan ? null : event;
  },
  dsn: __SENTRY_DSN__,
  environment: process.env.NODE_ENV,
  ignoreErrors,
  sampleRate: __SENTRY_SAMPLE_RATE__,
  tracesSampleRate: __SENTRY_TRACES_SAMPLE_RATE__,
};
